import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import App from './App';
import { logout } from 'redux/auth/AuthActions';
import { checkPermissions } from 'redux/manageUser/ManageUserActions';
import { setContext } from 'redux/contexts/ContextsActions';
import { withRouter } from 'react-router-dom';

const mapStateToProps = ({ contexts, authentication, manageUser }) => ({
  user: contexts.user,
  selectedOrg: contexts.selectedOrg,
  orgTree: contexts.orgTree,
  userLogged: authentication.logged,
  isFetchingPermissions: manageUser.isFetchingPermissions
});

const mapDispatchToProps = dispatch => ({
  authActions: bindActionCreators({ logout }, dispatch),
  manageUserActions: bindActionCreators({ checkPermissions }, dispatch),
  contextsActions: bindActionCreators({ setContext }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));


// WEBPACK FOOTER //
// ./src/components/app/AppConnector.js